//------------------------------------------------------------------------------
//     This code was generated by a tool.
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
//------------------------------------------------------------------------------  
enum AccurateBackgroundCheckStatus {

  Active = 1,

  Pending = 2,

  Cancelled = 3,

  Failed = 4,

  None = 5,

}

export default AccurateBackgroundCheckStatus;